import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';
import { Session } from '@/types/session.types';

const saveWorkingProjectSessionReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Session>) => {
    // These updates trigger in a debounce inside of save-session-middleware.ts
    state.savingWorkingProject = true;
    if (state.workingProject?.sessions) {
      // updatedSessionUuid is required to keep track of the session that is being updated in save-session-middleware.ts
      const sessionData = action.payload;
      state.updatedSessionUuid = action.payload.uuid;
      state.workingProject.sessions = state.workingProject.sessions.map((s) => {
        if (s.uuid === action.payload.uuid) {
          return action.payload;
        }
        return s;
      });

      if (sessionData.uuid === state.workingSession?.uuid) {
        state.workingSession = {
          ...state.workingSession,
          ...sessionData,
        };
      }
    }
  });
};

export default saveWorkingProjectSessionReducer;
